import PAY_STEPS from "~/components/parking/config/payFlow"
import FIGHT_STEPS from "~/components/parking/config/fightFlow"

import { PARKING_FLOW_TYPE } from "~/utilities/constants"

export const stepSorter = (stepA, stepB) => {
  return stepA.order - stepB.order
}

export const PARKING_FLOW_STEPS = {
  [PARKING_FLOW_TYPE.fight]: FIGHT_STEPS.sort(stepSorter),
  [PARKING_FLOW_TYPE.pay]: PAY_STEPS.sort(stepSorter),
  [PARKING_FLOW_TYPE.robotpay]: PAY_STEPS.sort(stepSorter)
}

/**
 * get step from slug name
 * @param {string} slug step slug to get
 * @param {array<Steps>} steps steps to filter
 */
export const getStep = (slug, steps) => {
  if (
    typeof slug !== "string" ||
    !slug ||
    !slug.length ||
    !steps ||
    !steps.length
  ) {
    return null
  }
  return steps.reduce((step, curr) => {
    if (curr.slug === slug.toLowerCase()) return curr
    return step
  }, steps[0])
}

export const getNextStep = (currentSlug, steps) => {
  if (!currentSlug) return null
  const currentStep = getStep(currentSlug, steps)
  const result = steps.filter(step => step.order === currentStep.order + 1)
  if (result.length === 1) return result[0]
  return null
}

export const getPreviousStep = (currentSlug, steps) => {
  if (!currentSlug) return null
  const currentStep = getStep(currentSlug, steps)
  if (currentSlug.order === 0) return null
  const result = steps.filter(step => step.order === currentStep.order - 1)
  if (result.length === 1) return result[0]
  return null
}
